import { render, staticRenderFns } from "./ViewShare.vue?vue&type=template&id=56130e5e"
import script from "./ViewShare.vue?vue&type=script&lang=js"
export * from "./ViewShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports